import React, { useEffect, useState } from "react"
import { admin } from "../../config/apiEndpoints"
import { Badge, Card, Col, Row, Stack, Table } from "react-bootstrap"
import PageTitleButton from "../../components/PageTitleButton"
import axiosProvider from "../../lib/AxiosProvider"
import { useParams } from "react-router-dom"
import {
  getStatusClassName,
  useHandleUnauthorizedAccess,
} from "../../lib/GlobalMethods"
import { toast } from "react-toastify"
import useDebounce from "../../lib/hooks/useDebounce"
import InfiniteScroll from "react-infinite-scroll-component"
import BookingManagementSkeleton from "../../skeleton/bookingManagement"
import moment from "moment"
import BookingDetails from "../bookingManagement/BookingDetails"

const UserDetails = () => {
  const [data, setData] = useState(null)
  const [bookingData, setBookingData] = useState(false)
  const [loading, setLoading] = useState(true)
  const [show, setShow] = useState(false)
  const [pagination, setPagination] = useState({
    current_page: 1,
    total_pages: false,
  })
  const [recordsCount, setRecordsCount] = useState({
    total_records: false,
    active_records: false,
    archived_records: false,
  })
  const [searchQuery, setSearchQuery] = useState("")
  const [hasMore, setHasMore] = useState(true)
  const [isView, setIsView] = useState(false)

  const debouncedSearchQuery = useDebounce(searchQuery, 500)

  const { handleAccess } = useHandleUnauthorizedAccess()

  const handleShow = () => setShow(true)
  const handleClose = () => {
    setShow(false)
  }
  const { id } = useParams()
  const isFleetUser =
    ["FLEET", "MIXED"].includes(data?.user_type) ||
    Number(data?.fleet_booking_count || 0) > 0
  const userTypeLabel =
    data?.user_type === "MIXED"
      ? "Fleet + Normal"
      : isFleetUser
        ? "Fleet User"
        : "Normal User"

  const fetchData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: "GET",
        endpoint: `${admin.endUserList}?enduser_id=${id}`,
      })

      setData(response?.data?.data[0])

      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const fetchBookingData = async (searchQuery) => {
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: `${admin.bookingList}?page=${
          pagination.current_page
        }&search_term=${searchQuery ? searchQuery : ""}&user_id=${id}`,
      })

      const fetchedData = response?.data?.data || []
      setHasMore(true)

      handleAccess({ code: response?.data?.code })

      response?.data?.code === 200 && setPagination(response?.data?.pagination)
      response?.data?.code === 200 &&
        setRecordsCount(response?.data?.record_counts)

      if (
        !fetchedData.length ||
        response.data.pagination.current_page ===
          response.data.pagination.total_pages
      ) {
        setHasMore(false)
      }

      setBookingData((prevData) =>
        pagination.current_page === 1
          ? fetchedData
          : [...prevData, ...fetchedData],
      )

      setLoading(false)
    } catch (error) {
      setLoading(false)
      toast.error(error.message || "An error occurred")
    }
  }

  const fetchMorBookingData = () => {
    if (pagination.current_page < pagination.total_pages) {
      setPagination((prevState) => ({
        ...prevState,
        current_page: prevState.current_page + 1,
      }))
    } else {
      setHasMore(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    fetchBookingData(debouncedSearchQuery)
  }, [debouncedSearchQuery, pagination.current_page])

  return (
    !loading && (
      <>
        <PageTitleButton leftArrow={true} PagetitleText={"User Details"} />
        {data?.deletedAt && <p className="text-danger">{data?.reason || ""}</p>}
        <div className="userperson_details_wrapper mb-3 ctmcard_shadow">
          <Row xs="auto" className="m-0 gap-3">
            <Col className="p-0">
              <div className="userprofile">
                {data?.profile_img ? (
                  <img
                    src={
                      data?.profile_img?.startsWith("/")
                        ? process.env.REACT_APP_RESOURCE_URL + data?.profile_img
                        : data?.profile_img
                    }
                    alt={data?.name}
                    className="uravtar_img"
                  />
                ) : (
                  <i
                    className="avtar_nm"
                    data-name={
                      data?.name
                        ? data?.name
                            ?.split(" ")
                            .map((word) => word.charAt(0).toUpperCase())
                            .join("")
                        : "-"
                    }
                  ></i>
                )}

                <div className="user_nmem">
                  <h2 className="nmtitle_user">{data?.name}</h2>
                  {data?.phone ? (
                    <p className="user_phonmail d-flex align-items-center gap-1">
                      <i className="icon_main phone_icon"></i>
                      {data?.phone}
                    </p>
                  ) : null}
                  {data?.email ? (
                    <p className="user_phonmail d-flex align-items-center gap-1">
                      <i className="icon_main email_icon"></i>
                      {data?.email}
                    </p>
                  ) : null}
                  {data?.emergency_phone ? (
                    <p className="user_phonmail emergency_phone d-flex align-items-center gap-1">
                      <i className="icon_main phone_icon"></i>
                      {data?.emergency_phone}
                    </p>
                  ) : null}
                </div>
              </div>
            </Col>
            <Col className="ms-md-auto p-0">
              <div className="numberdetail_charging">
                <p>No of Vehicles:</p>
                <span>
                  {(data?.vehicles_catalogues?.length || 0) +
                    (data?.fleet_vehicles?.length || 0)}
                </span>
              </div>
            </Col>
            <Col className="p-0">
              <div className="numberdetail_charging">
                <p>User Type:</p>
                <span>
                  {isFleetUser ? (
                    <Badge bg="info" text="dark">{userTypeLabel}</Badge>
                  ) : (
                    <Badge bg="secondary">{userTypeLabel}</Badge>
                  )}
                </span>
              </div>
            </Col>
            <Col className="p-0">
              <div className="numberdetail_charging">
                <p>Bookings:</p>
                <span>{data?.booking_count || 0}</span>
              </div>
            </Col>
            <Col className="p-0">
              <div className="numberdetail_charging">
                <p>Completed Charging:</p>
                <span>{data?.completed_charging_count || 0}</span>
              </div>
            </Col>
            <Col className="p-0">
              <div className="numberdetail_charging">
                <p>Cancelled Bookings:</p>
                <span>{data?.cancelled_charging_count || 0}</span>
              </div>
            </Col>
            <Col className="p-0">
              <div className="numberdetail_charging">
                <p>Sign Up:</p>
                <span>
                  {moment(data?.createdAt).format("DD MMMM YYYY") || ""}
                </span>
              </div>
            </Col>
          </Row>
        </div>
        {((data?.vehicles_catalogues?.length || 0) > 0 ||
          (data?.fleet_vehicles?.length || 0) > 0) && (
          <div className="mb-3">
            <h6 className="mb-2 text-body-secondary">Vehicle Details</h6>

            <div className="vehicle_cards_wrapper">
              <Row className="gy-4">
                {data?.vehicles_catalogues?.map((vec, index) => (
                  <Col md={12} lg={4} key={index + 1}>
                    <Card className="cmtcard_vehicle ctmcard_shadow">
                      <Card.Body>
                        <Stack
                          direction="horizontal"
                          className="align-items-start"
                          gap={3}
                        >
                          <div className="vehbrand_modalnm">
                            <h4 className="vehbrand_title">
                              {vec?.brand?.brand_name + " " + vec?.model}
                            </h4>
                            <span className="vehmodal_nm">
                              {vec?.vehicle_type}
                            </span>
                          </div>
                          <div className="ms-auto">
                            <img
                              src={
                                vec?.vehicle_img?.startsWith("http")
                                  ? vec?.vehicle_img
                                  : process.env.REACT_APP_RESOURCE_URL +
                                      vec?.vehicle_img ||
                                    "https://placehold.co/50x50.png"
                              }
                              alt="VehicleImage"
                              className="urvehicle_img"
                            />
                          </div>
                        </Stack>
                        <hr className="hr border-dashed" />
                        <Stack
                          direction="horizontal"
                          className="align-items-start justify-content-between"
                          gap={1}
                        >
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">
                              Battery Capacity
                            </h4>
                            <h6 className="vehiclefeature_value">
                              {vec?.battery_capacity}
                              <span className="vehiclefeature_unit">kWh</span>
                            </h6>
                          </div>
                          <div className="vr" />
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">Connector</h4>
                            {vec?.connectors?.map((connector, index) => (
                              <div key={index + 1}>
                                <h6 className="vehiclefeature_value">
                                  {connector?.connector_type}
                                  <span className="vehiclefeature_unit">
                                    ({connector?.current_type})
                                  </span>
                                </h6>
                              </div>
                            ))}
                          </div>
                          <div className="vr" />
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">Make Year:</h4>
                            <h6 className="vehiclefeature_value">2022</h6>
                          </div>
                        </Stack>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
                {data?.fleet_vehicles?.map((vehicle, index) => (
                  <Col md={12} lg={4} key={`fleet-${index + 1}`}>
                    <Card className="cmtcard_vehicle ctmcard_shadow">
                      <Card.Body>
                        <Stack
                          direction="horizontal"
                          className="align-items-start"
                          gap={3}
                        >
                          <div className="vehbrand_modalnm">
                            <h4 className="vehbrand_title">
                              {vehicle?.brand?.brand_name || "Fleet Vehicle"}{" "}
                              {vehicle?.model}
                            </h4>
                            <span className="vehmodal_nm">
                              {vehicle?.registration_number} ·{" "}
                              {vehicle?.vehicle_type}
                            </span>
                          </div>
                        </Stack>
                        <hr className="hr border-dashed" />
                        <Stack
                          direction="horizontal"
                          className="align-items-start justify-content-between"
                          gap={1}
                        >
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">
                              Battery Capacity
                            </h4>
                            <h6 className="vehiclefeature_value">
                              {vehicle?.battery_capacity}
                              <span className="vehiclefeature_unit">kWh</span>
                            </h6>
                          </div>
                          <div className="vr" />
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">Connector</h4>
                            {vehicle?.connectors?.map(
                              (connector, connectorIndex) => (
                                <h6
                                  className="vehiclefeature_value"
                                  key={connectorIndex + 1}
                                >
                                  {connector?.connector_type}
                                  <span className="vehiclefeature_unit">
                                    ({connector?.current_type})
                                  </span>
                                </h6>
                              ),
                            )}
                          </div>
                          <div className="vr" />
                          <div className="vehicle_features">
                            <h4 className="vehiclefeature_title">Make Year:</h4>
                            <h6 className="vehiclefeature_value">
                              {vehicle?.manufacturing_year}
                            </h6>
                          </div>
                        </Stack>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          </div>
        )}
        {bookingData?.length > 0 && (
          <>
            <h6 className="mb-2 text-body-secondary">Booking Details</h6>
            <div className="vehicle_cards_wrapper">
              <Card>
                <Card.Body>
                  <InfiniteScroll
                    dataLength={bookingData?.length}
                    next={fetchMorBookingData}
                    hasMore={hasMore}
                    loader={
                      <BookingManagementSkeleton
                        infiniteScroll={true}
                        rows={1}
                      />
                    }
                  >
                    <Table
                      className="rounded mb-0 table-striped overflow-x-auto"
                      responsive
                    >
                      <thead>
                        <tr>
                          <th className="text-center">Id</th>
                          <th>Vehicle Details</th>
                          <th className="text-center">Station Name</th>
                          <th className="text-center">Connector Type</th>
                          <th className="text-center">Status</th>
                          <th className="text-center lh-1">
                            Booking Date/ <br /> Slot time
                          </th>
                          <th className="text-center">Amount</th>
                          <th className="text-center">Payment method</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingData?.length > 0 &&
                          bookingData?.map((item, index) => (
                            <tr key={index + 1}>
                              <td
                                className="text-center text-primary"
                                onClick={() => {
                                  handleShow()
                                  setIsView(item)
                                }}
                                role="button"
                                tabIndex="0"
                              >
                                {item?.id}
                              </td>
                              <td>
                                <p className="mb-0 lh-1 text-nowrap d-flex align-items-center gap-2">
                                  {item?.fleet_vehicle && (
                                    <Badge bg="info" text="dark">Fleet</Badge>
                                  )}
                                  {item?.fleet_vehicle
                                    ? `${item.fleet_vehicle.model || "Fleet Vehicle"} (${item.fleet_vehicle.registration_number || item.fleet_vehicle.id})`
                                    : `${item?.vehicles_catalogue?.brand?.brand_name || ""} ${item?.vehicles_catalogue?.model || ""}`.trim() ||
                                      "-"}
                                </p>
                                <span className="fs_14 text_7gray text-nowrap">
                                  {item?.user?.phone}
                                </span>
                              </td>
                              <td className="text-center">
                                <p className="mb-0 lh-sm fs_14">
                                  {item?.station?.station_name}
                                </p>
                              </td>
                              <td>
                                <div className="sppted_connectors">
                                  <div className="connector_item position-relative">
                                    <span
                                      className="bg-body border border-opacity-75 d-inline-flex justify-content-center align-items-center fs_14 p-1 rounded-circle text-body text-uppercase position-absolute end-0"
                                      style={{ width: "22px", height: "22px" }}
                                    >
                                      {item?.charger_position
                                        .charAt(0)
                                        .toUpperCase()}
                                    </span>
                                    <img
                                      src={
                                        item?.connector?.connector_img
                                          ? process.env.REACT_APP_RESOURCE_URL +
                                            item?.connector?.connector_img
                                          : "https://placehold.co/50x50.png"
                                      }
                                      alt="connector_img"
                                      className="connector_item_img"
                                    />
                                    <span className="connector_nm">
                                      {item?.connector?.connector_type}
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td className="text-center">
                                <span
                                  className={`badges ${getStatusClassName(
                                    item.status,
                                  )} fs_14 fw-normal px-3 py-1`}
                                >
                                  {item?.status}
                                </span>
                              </td>
                              <td className="text-center fs_14">
                                <p className="mb-0 text_7gray lh-1">
                                  {item?.booked_start_time?.split(" ")[0]}
                                </p>
                                <span className="mb-0 text-uppercase fw-semibold">
                                  {moment(
                                    item?.booked_start_time?.split(" ")[1],
                                    "HH:mm:ss",
                                  ).format("hh:mm A")}
                                </span>
                              </td>
                              <td className="text-center">
                                ₹{item?.bookingwise_payment?.amount || 0}/-
                              </td>
                              <td className="text-center">
                                {item?.bookingwise_payment?.payment_method ||
                                  "-"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </InfiniteScroll>
                </Card.Body>
              </Card>
            </div>
            <BookingDetails
              show={show}
              handleClose={handleClose}
              isView={isView}
            />
          </>
        )}
      </>
    )
  )
}

export default UserDetails
